module.exports = __webpack_public_path__ + "img/investimento.41a3306f.svg";